import React from "react";
import { Menu, Sun, Moon, Monitor, CircleHelp, History, LayoutGrid } from "lucide-react";
import UrlBar from "../controls/UrlBar";
import IconButton from "../common/IconButton";

const THEME_ICON = { light: Sun, dark: Moon, system: Monitor };

function Header({ url, setUrl, onPreview, themeMode, onCycleTheme, onToggleSidebar, onToggleRightPanel, onHelp }) {
  const ThemeIcon = THEME_ICON[themeMode];

  return (
    <header className="app-header">
      <div className="app-header-brand">
        <IconButton
          label="Toggle device panel"
          className="mobile-only"
          onClick={onToggleSidebar}
        >
          <Menu size={20} strokeWidth={1.75} aria-hidden="true" />
        </IconButton>
        <span className="brand-mark" aria-hidden="true">
          <LayoutGrid className="brand-logo" size={18} strokeWidth={2} />
        </span>
        <span className="brand-name">
          Web<span className="brand-name-accent">Preview</span>
        </span>
      </div>

      <UrlBar url={url} setUrl={setUrl} onPreview={onPreview} />

      <div className="app-header-actions">
        <IconButton
          label={`Theme: ${themeMode}. Click to change.`}
          tooltip={`Theme: ${themeMode}`}
          onClick={onCycleTheme}
        >
          {/* Keyed by mode so the icon remounts and plays its swap animation. */}
          <ThemeIcon key={themeMode} className="theme-icon" size={18} strokeWidth={1.75} aria-hidden="true" />
        </IconButton>
        <IconButton label="Help and documentation" tooltip="Help" onClick={onHelp}>
          <CircleHelp size={18} strokeWidth={1.75} aria-hidden="true" />
        </IconButton>
        <IconButton
          label="Toggle history and sessions panel"
          className="mobile-only"
          onClick={onToggleRightPanel}
        >
          <History size={18} strokeWidth={1.75} aria-hidden="true" />
        </IconButton>
      </div>
    </header>
  );
}

export default Header;
